import Cookie from 'js-cookie';
import iosApi from './IOSAPI';


class SessionHelper {
    constructor() {
        this.mode = window.PristineAndroid ? 'android' : 'web';

        if(iosApi.supported) {
            this.api = iosApi;
            window.iosInterface = this.api.call.bind(this.api);
            this.mode = 'ios';
        }

        console.log('SessionHelper mode', this.mode);
    }


    getAPIKey() {
        if (this.mode == 'android') {
            var key = window.PristineAndroid.getAPIKey();
            console.log('SessionHelper android key', key);
            return key;
        }
        if(this.mode === 'ios') {
            var key = this.api.getAPIKey();
            console.log('SessionHelper ios key', key);
            return key;
        }

        return Cookie.get('_pristine_player__api_key');
    }


    setAPIKey(key) {
        if (this.mode == 'android') {
            window.PristineAndroid.setAPIKey(key);
            return;
        }
        if(this.mode === 'ios') {
            this.api.setAPIKey(key);
            return;
        }

        Cookie.set('_pristine_player__api_key', key);
    }


    forgetAPIKey() {
        if (this.mode == 'android') {
            window.PristineAndroid.forgetAPIKey();
            return;
        }
        if(this.mode === 'ios') {
            this.api.forgetAPIKey();
            return;
        }

        Cookie.remove('_pristine_player__api_key');
    }

}


var helper = new SessionHelper();
export default helper;



// WEBPACK FOOTER //
// ./src/SessionHelper.js